export const WARNING_DISPLAY_NAMES: Record<string, string> = {
  na_premium: "N/A premium in rater",
  used_default_construction_code:
    "Used default construction code due to missing data",
  used_default_occupancy_code:
    "Used default occupancy code due to missing data",
  extrapolated_premium: "Non-US location assigned account rate",
  substituted_zip: "Missing loss cost for zip, used nearby zip",
};

export type WarningLevel = "info" | "critical";

const CRITICAL_WARNING_KEYS = new Set(["na_premium"]);

export const warningSeverity = (key: string): WarningLevel =>
  CRITICAL_WARNING_KEYS.has(key) ? "critical" : "info";
